module.exports = __webpack_public_path__ + "static/the-infra-red-report-e24e8d2c15742f9bf543e9d8c106bfb8.png";